import React from "react";

const dispatchMessagesOverlay = (
  message: string | React.ReactNode,
  targetOverlay: string
) => {
  const event = new CustomEvent(targetOverlay, {
    detail: message
  });

  dispatchEvent(event);
};

export default dispatchMessagesOverlay;
